import { useEffect, useState } from 'react';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';

// Voci di menu dei portali Utenti/Allenatori accese o spente da Impostazioni → Ruoli
// (elenco in backend/src/modules/funzionalita/funzionalita.constants.ts). Qui servono solo
// a nascondere menu e pagine: il blocco delle azioni è sul server (richiedeVocePortale).
export const VOCE_DEL_PATH = {
  '/allenatore': 'PRESENZE', '/le-mie-presenze': 'PRESENZE',
  '/allenatore/contratti': 'CONTRATTI', '/le-mie-presenze/contratti': 'CONTRATTI',
  '/allenatore/documenti': 'DOCUMENTI', '/le-mie-presenze/documenti': 'DOCUMENTI',
  '/allenatore/anagrafica': 'DATI', '/le-mie-presenze/anagrafica': 'DATI',
  '/calendario-allenatori': 'CALENDARIO_ALLENATORI', '/le-mie-presenze/allenatori': 'CALENDARIO_ALLENATORI',
  '/allenatore/rimborsi': 'RIMBORSI', '/le-mie-presenze/rimborsi': 'RIMBORSI',
  '/allenatore/guida': 'GUIDA_ALLENATORI', '/le-mie-presenze/guida': 'GUIDA_ALLENATORI',
  '/le-mie-presenze/fipav': 'FIPAV', '/le-mie-presenze/aibvc': 'AIBVC',
  '/cliente': 'HOME', '/cliente/catalogo': 'CATALOGO', '/cliente/ordine': 'NUOVO_ORDINE',
  '/cliente/ordini': 'MIEI_ORDINI', '/cliente/campi': 'AFFITTO_CAMPO', '/cliente/tessera': 'TESSERA', '/le-mie-presenze/tessera': 'TESSERA',
  '/cliente/profilo': 'PROFILO', '/cliente/tickets': 'SUPPORTO', '/cliente/guida': 'GUIDA_UTENTI',
  '/cliente/socio': 'DIVENTA_SOCIO', '/cliente/fipav': 'FIPAV', '/cliente/ricevute': 'RICEVUTE', '/cliente/aibvc': 'AIBVC',
};
const SOLO_ALLENATORE = ['PRESENZE', 'CONTRATTI', 'DOCUMENTI', 'DATI', 'CALENDARIO_ALLENATORI', 'RIMBORSI', 'GUIDA_ALLENATORI'];

// Portale di chi guarda: ALLENATORE per il ruolo allenatore e per le voci da allenatore di uno staff-allenatore
export const portaleDi = (user, chiave) =>
  user?.ruolo === 'ALLENATORE' || SOLO_ALLENATORE.includes(chiave) ? 'ALLENATORE' : 'UTENTE';

// Cache per utente: si ricarica a ogni login/cambio account. Se la richiesta fallisce (es. partita
// prima del login) non si memorizza niente, così al giro dopo si riprova invece di restare "tutto acceso".
let cache = null;
let cacheUtente = null;
let inCorso = null;
let fallito = false;
const ascoltatori = new Set();
const carica = (uid) => {
  if (!inCorso) {
    inCorso = api.get('/funzionalita/stato')
      .then(r => { cache = r.data || {}; cacheUtente = uid; fallito = false; })
      .catch(() => { cache = null; cacheUtente = null; fallito = true; })
      .finally(() => { inCorso = null; ascoltatori.forEach(f => f(cache)); });
  }
  return inCorso;
};
export const ricaricaVociPortale = () => { cache = null; return carica(cacheUtente); };

// attiva(chiave, user): voce senza chiave → sempre visibile; spenta solo se lo stato lo dice
export const useVociPortale = () => {
  const { user } = useAuth();
  const uid = user?.id ?? null;
  const [stato, setStato] = useState(cacheUtente === uid ? cache : null);
  useEffect(() => {
    ascoltatori.add(setStato);
    if (!uid) setStato(null);
    else if (!cache || cacheUtente !== uid) { cache = null; carica(uid); }
    else setStato(cache);
    return () => { ascoltatori.delete(setStato); };
  }, [uid]);
  const attiva = (chiave, u) => !chiave || stato?.[portaleDi(u, chiave)]?.[chiave] !== false;
  return { pronto: !!stato, fallito: !stato && fallito && !inCorso, attiva, attivaPath: (path, u) => attiva(VOCE_DEL_PATH[path], u) };
};
